import React from "react";

const MarkAsHighPriority = () => {
  return (
    <React.Fragment>
      <div className="accHead">Mark as High Priority</div>
      <div className="accBody">asdasd</div>
    </React.Fragment>
  );
};

export default MarkAsHighPriority;
